import { put } from 'redux-saga/effects';
import { Types } from './actions';

function parseJwt2(token: string) {
  return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
}

export default function* execute({ token }: any): any {
  try {
    yield put({ type: Types.GET_PROFILE_REQUEST });
    const tokenParsed = parseJwt2(token);
    const { given_name: firstName } = tokenParsed;

    yield put({
      type: Types.GET_PROFILE_SUCCESS,
      data: {
        firstName,
        isAdm:
          tokenParsed?.resource_access?.['utpmas-info-web']?.roles?.includes(
            'Editor'
          )
      }
    });

    window?.dataLayer.push({ isLogged: 'true' });
  } catch (error) {
    window?.dataLayer.push({ isLogged: 'false' });
    yield put({
      type: Types.GET_PROFILE_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del estudiante.'
    });
  }
}
